import { translations } from '../../../../translations';

import { InputCheckItem } from '../../form-inputs';
import { IBaseInputCheckItem } from '../../types';

type TRememberMeCheckFieldProps = Pick<
  IBaseInputCheckItem,
  'checked' | 'onChange' | 'title'
>;

/**
 * -----------------------------------------------------------------------------
 * This toggles the remember me field for the user. If set, tha app will try to
 * remember the current session.
 */
export function RememberMeCheckField({
  checked,
  onChange,
  title,
}: TRememberMeCheckFieldProps) {
  return (
    <InputCheckItem
      checked={checked}
      label={translations.formFields.rememberMe}
      name="rememberMe"
      onChange={onChange}
      required={false}
      title={title || translations.formFields.rememberMeTitle}
    />
  );
}
